import { LOCAL_STORAGE_KEYS } from "@config/constant";
import { syncDailyMarketReadToNativeIfInApp } from "./dailyMarketReadNativeSync";

export type DailyMarketReadLocalState = Record<string, string>;

const DATE_PATTERN = /^\d{8}$/;

function isValidDate(value: unknown): value is string {
  return typeof value === "string" && DATE_PATTERN.test(value);
}

function readAll(): DailyMarketReadLocalState {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const raw = localStorage.getItem(
      LOCAL_STORAGE_KEYS.DAILY_MARKET_LAST_READ_DATE,
    );
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") {
      return {};
    }

    const next: DailyMarketReadLocalState = {};
    for (const [ownerId, date] of Object.entries(
      parsed as Record<string, unknown>,
    )) {
      if (ownerId && isValidDate(date)) {
        next[ownerId] = date;
      }
    }
    return next;
  } catch {
    return {};
  }
}

function writeAll(state: DailyMarketReadLocalState): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.DAILY_MARKET_LAST_READ_DATE,
      JSON.stringify(state),
    );
  } catch {
    // ignore quota / privacy mode errors
  }
}

export function readDailyMarketLastReadDate(ownerId: string): string | null {
  if (!ownerId) {
    return null;
  }

  const date = readAll()[ownerId];
  return isValidDate(date) ? date : null;
}

export function writeDailyMarketLastReadDate(
  ownerId: string,
  date: string,
): void {
  if (!ownerId || !isValidDate(date)) {
    return;
  }

  const all = readAll();
  all[ownerId] = date;
  writeAll(all);
  syncDailyMarketReadToNativeIfInApp(ownerId, date);
}
